module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/logo-businessinsider.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/logo-businessinsider.png
// module id = 1215
// module chunks = 0